<template>
  <i class="material-icons action-icon" @click="showEditModal">
    mode_edit
  </i>
</template>

<script>
import eventHub from "../eventHub.js";

export default {
  name: "edit-category-trigger",
  props: {
    categoryId: String,
  },
  methods: {
    showEditModal() {
      // FIXME - REFACTOR SO WE"RE NOT PASSING ALL THESE VALUES INDIVIDUALLY
      eventHub.$emit("show-category-modal", {
        modalType: "edit",
        categoryId: this.categoryId,
      });
    },
  },
};
</script>

<style scoped>
.material-icons.action-icon {
  font-size: 18px;
  margin: 0.25rem;
  color: #eee;
  transition: color 0.5s ease, opacity 0.5s ease 0.25s;
}

.material-icons.action-icon:hover {
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// EditCategoryTrigger.vue?4db70ada